import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { userDelete, disableMember, enableMember, quitMember
// unitRoles,
// listUserAssignedRoles,
} from "@/service/structure";
import ShowEncInput from "@/components/Common/ShowEncInput";
// import UCascaderCheck from "@/views/MGT/Organizational/Components/u-cascader-check.vue";

import { mapState } from "vuex";
export default {
  name: "UserDetail",
  components: {
    ShowEncInput
    // UCascaderCheck,
  },
  props: {
    org: {
      type: Object,
      default() {
        return {};
      }
    },
    item: {
      type: null,
      default() {
        return null;
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    ...mapState(["user"]),
    statuesName() {
      return this.data.status === 50 ? $t("eymx2", "启用") : $t("lb5z2", "禁用");
    },
    ...mapState({
      language: state => state.app.language
    }),
    showAddSms() {
      return (this.item ? Number(this.item.status) === 0 : false) && !this.showOff && this.isAdmin;
    },
    showDisableOn() {
      return this.showOff && (this.data.status === 10 || this.data.status === 50);
    },
    showDisableOff() {
      return !this.showOff && (this.data.status === 10 || this.data.status === 50);
    },
    isAdmin() {
      return this.user.userInfo.isAdmin === "T";
    },
    dataSex() {
      let obj = {
        "": $t("dd1tam4", "暂无设置"),
        0: $t("n5j1", "男"),
        1: $t("ho31", "女")
      };
      return obj[this.data.sex];
    },
    dataStatus() {
      let obj = {
        0: $t("ep0os3", "待邀请"),
        10: $t("fj1g2", "在职"),
        50: $t("lb5z2", "禁用"),
        99: $t("ler52", "离职")
      };
      return obj[`${this.data.status}`];
    },
    showDeparture() {
      return this.data.status === 10 || this.data.status === 50;
    }
  },
  data() {
    return {
      data: {},
      showOff: true
      // roleList: [],
    };
  },
  // watch: {
  //   "org.actionValue": function (val) {
  //     if (val === "3") {
  //       this.init();
  //     } else {
  //       this.clean();
  //     }
  //   },
  // },
  methods: {
    init() {
      this.data = {
        ...this.item
      };
      this.showOff = this.data.status === 50;
      // this.getUnitRoles();
    },
    clean() {
      this.data = {};
      // this.roleList = [];
    },
    cancel() {
      this.$emit("cancel");
    },
    edit() {
      this.$emit("editUser", this.item);
    },
    async deleteUser() {
      const params = {
        userIds: this.data.userId,
        orgIds: this.org.orgId
      };
      let res = await userDelete(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("azeh8z4", "删除成功"));
        this.$emit("update");
      }
    },
    async onDeparture() {
      const params = {
        userIds: `${this.data.userId}`,
        unitId: this.data.organizations.map(v => v.unitId).join(",")
      };
      let res = await quitMember(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("d1spvi4", "操作成功"));
        this.data.status = 99;
      }
    },
    addSms() {
      const params = {
        userId: this.item.userId,
        orgId: this.item.orgId
      };
      this.$emit("smsGot", params);
    },
    isAdminNameFn(isAdmin) {
      if (isAdmin === "T") {
        return $t("io38z3", "管理员");
      } else {
        return $t("aan4n54", "企业成员");
      }
    },
    orgFn(arr = []) {
      return arr.map(v => {
        return v.name;
      }).join(" , ");
    },
    /*
     ** 启用
     */
    async onOpen() {
      const params = {
        userIds: this.data.userId,
        unitId: this.data.organizations.map(v => v.unitId).join(",")
      };
      let res = await enableMember(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("b3vqjs4", "启用成功"));
        this.showOff = false;
      }
    },
    /*
     **  禁用
     */
    async onOff() {
      const params = {
        userIds: this.data.userId,
        unitId: this.data.organizations.map(v => v.unitId).join(",")
      };
      let res = await disableMember(params);
      if (res.data && res.data.result === 0) {
        this.$Message.success($t("ftc7864", "禁用成功"));
        this.showOff = true;
      }
    }
    /*
     * 获取角色列表
     */
    // async getUnitRoles() {
    //   let res = await unitRoles();
    //   if (res.data && res.data.result === 0) {
    //     this.roleList = res.data.retVal;
    //     if (this.item) {
    //       this.getListUserAssignedRoles();
    //     }
    //   }
    // },
    /*
     * 获取已绑定角色用户信息
     */
    // async getListUserAssignedRoles() {
    //   const params = {
    //     userId: this.item.userId,
    //   };
    //   let res = await listUserAssignedRoles(params);
    //   if (res.data && res.data.result === 0) {
    //     let roleIds = res.data.retVal.roleIds;

    //     this.roleList.forEach((v) => {
    //       v.children.forEach((c) => {
    //         if (roleIds.some((s) => `${s}` === c.roleId)) {
    //           this.$set(c, "checked", true);
    //           this.$set(v, "checked", true);
    //         }
    //       });
    //     });
    //   }
    // },
  },
  mounted() {
    this.init();
  }
};